import { css } from '@emotion/react';
import chroma from 'chroma-js';
import { CSSProperties } from 'react';
import { semantic_colors, shapes, text_styles } from '../../foundation';
import { getInputSpacingBySize } from '../input/styles';
import { InputSize } from '../input/types';

const TIME_PICKER_SMALL_INPUT_PADDING = '5px 10px';

// Time picker small inputs keep 5px vertical padding for the typed HH:mm field inside a 32px control.
export const getTimePickerInputSpacingBySize = (size: InputSize) => {
  return size === 'small' ? 6 : getInputSpacingBySize(size);
};

export const getTimePickerInputStyleBySize = (size?: InputSize): CSSProperties | undefined => {
  if (size !== 'small') return undefined;

  return {
    columnGap: getTimePickerInputSpacingBySize(size),
    padding: TIME_PICKER_SMALL_INPUT_PADDING,
  };
};

export const getTimePickerInputWrapperStyleBySize = (size?: InputSize) => {
  if (size !== 'small') return undefined;

  return css`
    column-gap: ${getTimePickerInputSpacingBySize(size)}px;
    padding: ${TIME_PICKER_SMALL_INPUT_PADDING};
  `;
};

export const time_picker_group_css = css`
  background-color: ${semantic_colors.background.surface};
  padding: 8px;
  ${shapes.shadow.low};
  ${shapes.border_radius.small};
  &:focus {
    outline: 3px solid ${semantic_colors.tab_focus};
  }
  &:focus:not(:focus-visible) {
    outline: none;
  }
`;

const TIME_CHIP_SCROLL_FADE_WIDTH = 16;

export const time_chip_input_root_css = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0;
  align-self: stretch;
  width: 0;
  min-width: 100%;
`;

export const time_chip_group_css = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-self: stretch;
`;

export const time_chip_label_css = css`
  ${text_styles.Body_13_SemiBold};
  color: ${semantic_colors.content.secondary};
`;

export const time_chip_scroll_wrapper_css = css`
  position: relative;
`;

export const time_chip_scroll_css = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const time_chip_scroll_fade_css = css`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: ${TIME_CHIP_SCROLL_FADE_WIDTH}px;
  pointer-events: none;
  background: linear-gradient(
    90deg,
    ${chroma(semantic_colors.background.surface).alpha(0).css()} 0%,
    ${semantic_colors.background.surface} 100%
  );
`;

export const time_chip_scroll_fade_left_css = css`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: ${TIME_CHIP_SCROLL_FADE_WIDTH}px;
  pointer-events: none;
  background: linear-gradient(
    270deg,
    ${chroma(semantic_colors.background.surface).alpha(0).css()} 0%,
    ${semantic_colors.background.surface} 100%
  );
`;

export const range_input_default_style = {
  'border': 0,
  'borderRadius': 0,
  'backgroundColor': 'transparent',
  'padding': 0,
  'height': 'auto',
  'transition': 'none',
  '&:hover': {
    borderColor: 'transparent',
  },
  '&:focus, &:focus-within': {
    outline: 'none',
    border: 'none',
  },
};
